module.exports = __webpack_public_path__ + "img/icon3.18a31081.png";